import {backend} from "../../../../../xconvert-backend";
import {authentication} from "../../../../../authentication";

export interface ScoredTicket {
    ticketId: number;
    iid: number;
    ticketName?: string;
    ticketText?: string;
    labels?: string[];
    labelDetails?: ScoredTicketLabel[];
    webUrl?: string;
    score: number;
    state?: string;
}

export interface ScoredTicketLabel {
    name: string;
    color?: string;
    textColor?: string;
}

export interface ScoredUnassignedTicketsResponse {
    tickets: ScoredTicket[];
}

export interface AnalyzeTicketForPickupRequest {
    ticketId: number;
    ticketName?: string;
    ticketText?: string;
    score: number;
    labels?: string[];
}

export interface AnalyzeTicketForPickupResponse {
    suggestion: string;
    difficultyAssessment: string;
    reasoning: string;
    recommendedOrder?: string;
}

export interface TopTicketRecommendation {
    ticketId: number;
    rank: number;
    suggestion: string;
    reasoning: string;
    difficultyAssessment: string;
}

export interface RecommendTopTicketsResponse {
    recommendations: TopTicketRecommendation[];
}

export async function recommendTopTicketsForPickup(
    tickets: ScoredTicket[]
): Promise<RecommendTopTicketsResponse> {
    const auth = await backend.withTokenAuthHeader(authentication.token);
    const headers: Record<string, string> = { "Content-Type": "application/json" };
    Object.assign(headers, auth.headers);

    const response = await fetch("/api/internal/recommendTopTicketsForPickup", {
        method: "POST",
        headers,
        body: JSON.stringify({ tickets }),
    });
    if (!response.ok) {
        throw new Error(`Failed to get recommendations: ${response.statusText}`);
    }
    return response.json();
}

export async function fetchScoredUnassignedTickets(
    includeGenericAi?: boolean
): Promise<ScoredUnassignedTicketsResponse> {
    const auth = await backend.withTokenAuthHeader(authentication.token);
    const headers: Record<string, string> = { "Content-Type": "application/json" };
    Object.assign(headers, auth.headers);

    const url =
        includeGenericAi === true
            ? "/api/internal/scoredUnassignedTickets?includeGenericAi=true"
            : "/api/internal/scoredUnassignedTickets";
    const response = await fetch(url, { headers });
    if (!response.ok) {
        throw new Error(`Failed to fetch scored tickets: ${response.statusText}`);
    }
    return response.json();
}

export async function analyzeTicketForPickup(request: AnalyzeTicketForPickupRequest): Promise<AnalyzeTicketForPickupResponse> {
    const auth = await backend.withTokenAuthHeader(authentication.token);
    const headers: Record<string, string> = { "Content-Type": "application/json" };
    Object.assign(headers, auth.headers);

    const response = await fetch("/api/internal/analyzeTicketForPickup", {
        method: "POST",
        headers,
        body: JSON.stringify(request),
    });
    if (!response.ok) {
        throw new Error(`Failed to analyze ticket: ${response.statusText}`);
    }
    return response.json();
}
